<template>
  <div>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              id="reservation-tbl"
            >
              <template #columns>
                <th>{{ $t("ID") }}</th>
                <th>{{ $t("ReservationStore") }}</th>
                <th>{{ $t("ReservationRequester") }}</th>
                <th>
                  <div class="w-full flex">
                    <span style="width: 60%">{{ $t("ProductName") }}</span>
                    <span class="pl-6" style="width: 20%">{{
                      $t("ItemCode")
                    }}</span>
                    <span style="width: 10%">{{ $t("Shelve") }}</span>
                    <span style="width: 10%">{{ $t("Count") }}</span>
                  </div>
                </th>
                <th>{{ $t("CreationDate") }}</th>
                <th>{{ $t("Description") }}</th>
              </template>
              <template slot-scope="{ row }">
                <td style="width: 5%">
                  {{ row.id }}
                </td>
                <td style="width: 10%">
                  {{ row.reservationStoreInfoQuery.name }}
                </td>
                <td style="width: 12%">
                  {{ row.reservationRequesterQuery.name }}
                </td>
                <template>
                  <td style="width: 45%">
                    <table>
                      <tr
                        v-for="item in row.reservationTransactionItemQueries"
                        :key="item.id"
                      >
                        <td style="width: 60%">{{ item.stockName }}</td>
                        <td style="width: 20%">
                          {{ item.itemCode ? item.itemCode : "-" }}
                        </td>
                        <td style="width: 10%">{{ item.shelveName }}</td>
                        <td style="width: 10%">{{ item.count }}</td>
                      </tr>
                    </table>
                  </td>
                </template>
                <td style="width: 10%; direction: ltr">
                  {{ row.persianDateTime }}
                </td>
                <td style="width: 13%; direction: ltr">
                  {{
                    row.reasonQuery.description
                      ? row.reasonQuery.description
                      : "-"
                  }}
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
#reservation-tbl table td {
  font-size: 14px;
}
</style>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  name: "warehouseManagement_invwetoryReservations_Reserves",
  components: {
    DataGrid,
  },
  data() {
    return {
      ModifyPopup: false,
      modalModel: {},
      gridDataSource: {
        type: "app",
        service: "Inventory/api/ReservationQuery",
      },
      gridSearchData: { reservationType: 1 },
    };
  },
};
</script>
